export const MIN_LAUNCHER_WIDTH = 200;
export const launcherWidth = 60;
export const launcherHeight = 60;
export const ungatedForCustomerAgentPromptsLauncherWidth = 40;
export const ungatedForCustomerAgentPromptsLauncherHeight = 40;
export const ungatedForCustomerAgentPromptsOpenIconWidth = 26;
export const ungatedForCustomerAgentPromptsOpenIconHeight = 24;